var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.dynamicComponent,{tag:"component",attrs:{"boardRef":_vm.boardRef,"entity-id":_vm.entityId}})
}
var staticRenderFns = []

export { render, staticRenderFns }